var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Logo","contain":"","src":_vm.company.base64Logo ? `data:image/png;base64,${_vm.company.base64Logo}` : '',"transition":"scale-transition","width":"50"},on:{"click":function($event){return _vm.$router.push('/')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }